import { EmbeddedPreview } from '@verbit-ai/file-floater'

import { useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { useTranscriptHighLight } from 'src/contexts/TranscriptHighLightContext'

import * as S from './styles'

export const DocumentViewer = () => {
    const { fileFloaterRef } = useTranscriptHighLight()

    const metadata = useTranscriptMetadata()

    const fileUrl = metadata?.fileUrl || ''

    return (
        <S.Container>
            <EmbeddedPreview fileUrl={fileUrl} ref={fileFloaterRef} />
        </S.Container>
    )
}
